var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrame49(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_501_1784)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 30,
    width: 68,
    height: 68,
    rx: 17,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8334 49.8335H58.2984C59.8284 49.8335 61.0325 51.151 60.905 52.6668L62.9167 67.3718C63.625 70.3752 64.135 71.0693 66.4584 71.0693H78.7692C80.8092 71.0693 80.625 69.6668 81.3334 67.3718L83.515 56.7468C83.685 54.3952 81.9 52.4827 79.5342 52.4827H61.2451",
    stroke: "#CC99FF",
    strokeWidth: 2.125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0208 78.1667C76.9988 78.1667 77.7917 77.3738 77.7917 76.3958C77.7917 75.4178 76.9988 74.625 76.0208 74.625C75.0428 74.625 74.25 75.4178 74.25 76.3958C74.25 77.3738 75.0428 78.1667 76.0208 78.1667Z",
    stroke: "#CC99FF",
    strokeWidth: 2.125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6875 78.1667C65.6655 78.1667 66.4583 77.3738 66.4583 76.3958C66.4583 75.4178 65.6655 74.625 64.6875 74.625C63.7095 74.625 62.9166 75.4178 62.9166 76.3958C62.9166 77.3738 63.7095 78.1667 64.6875 78.1667Z",
    stroke: "#CC99FF",
    strokeWidth: 2.125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6666 58.3335H82.75",
    stroke: "#CC99FF",
    strokeWidth: 2.125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.7083,
    y: 30.7083,
    width: 66.5833,
    height: 66.5833,
    rx: 16.2917,
    stroke: "#00FF66",
    strokeWidth: 1.41667,
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_501_1784",
    x: 0.583332,
    y: 0.249999,
    width: 138.833,
    height: 138.833,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.66667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.7083
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_501_1784"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_501_1784",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame49);
export default __webpack_public_path__ + "static/media/frame49.e17088e9501e17d65daebc285e299eb1.svg";
export { ForwardRef as ReactComponent };